import { useRef, useState } from 'react'
import RowTitle from './RowTitle'
// import Switch from "./Switch";
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { primary_color } from '../../Helper/uiHelper'
import ReactSwitch from 'react-switch'
import { tidyName } from '../../helper'
import { updatePermission } from '../../Helper/permissionHelper'
import { useSelector } from 'react-redux'
import ManagePermissionRole from './managePermissionRole'
import Loader from 'react-loaders'

const CMSPermissionPanel = ({ currentPermission, role_id, permissionLoading }) => {
  const [isWarning, setIsWarning] = useState(false)
  const warningItem = useRef()

  const reduxQueue = useSelector((state) => state.Queue.queues)
  const isManagePermissionRoleEnabled = useSelector((state) => state.User?.user?.cmsSettingPermission?.manage_roles)?.[0]?.enabled
  const isChangePermissionRoleEnabled = useSelector((state) => state.User?.user?.cmsSettingPermission?.assign_roles_to_users)?.[0]?.enabled

  const addPermissionArray = []
  const removePermissionArray = []

  reduxQueue?.map((queue) => {
    if (queue.url === 'update-role-wise-permission') {
      queue.payload?.data?.permissions?.map((permission) => {
        if (permission?.add_ids) {
          permission?.add_ids?.map((item) => {
            addPermissionArray?.push(item)
          })
        }
        if (permission?.remove_ids) {
          permission?.remove_ids?.map((item) => {
            removePermissionArray?.push(item)
          })
        }
      })
    }
  })

  const isManagePermissionEnabled = currentPermission?.cmsSetting?.manage_roles?.[0]?.enabled
  const managePermissionId = currentPermission?.cmsSetting?.manage_roles?.[0]?.permission_id

  let isManagePermissionActive = false
  if (!isManagePermissionEnabled && addPermissionArray?.includes(managePermissionId)) {
    isManagePermissionActive = true
  }
  if (isManagePermissionEnabled && !removePermissionArray?.includes(managePermissionId)) {
    isManagePermissionActive = true
  }

  const isChangePermissionEnabled = currentPermission?.cmsSetting?.manage_roles?.[0]?.enabled
  const changePermissionId = currentPermission?.cmsSetting?.manage_roles?.[0]?.permission_id

  let isChangePermissionActive = false
  if (!isChangePermissionEnabled && addPermissionArray?.includes(changePermissionId)) {
    isChangePermissionActive = true
  }
  if (isChangePermissionEnabled && !removePermissionArray?.includes(changePermissionId)) {
    isChangePermissionActive = true
  }

  if (permissionLoading) {
    return (
      <div className='d-flex flex-column justify-content-center align-items-center ' style={{ marginTop: '10rem' }}>
        {' '}
        <div>
          <Loader type='ball-pulse' color='blue' />
        </div>
        <div className='subtitle1 text-muted'>Please wait while the data is being synchronized.</div>
      </div>
    )
  }

  return (
    <>
      <div className='cms-permission-panel' style={{ maxHeight: '75vh' }}>
        <RowTitle title={'Cms Permissions'} />
        <div className='content'>
          {currentPermission?.cmsSetting &&
            Object.keys(currentPermission?.cmsSetting).map((key) => {
              const item = currentPermission?.cmsSetting?.[key]?.[0]

              let isItemActive = false

              if (!item?.enabled && addPermissionArray?.includes(item?.permission_id)) {
                isItemActive = true
              }
              if (item?.enabled && !removePermissionArray?.includes(item?.permission_id)) {
                isItemActive = true
              }
              if (['assign_roles_to_users', 'add_role', 'manage_roles'].includes(key) && !isManagePermissionRoleEnabled) {
                return
              }
              if (key === 'assign_roles_to_users' && !isManagePermissionActive) return
              if (key === 'add_role' && !isManagePermissionActive) return
              return (
                <div className='d-flex mb-4'>
                  <ReactSwitch
                    checked={isItemActive}
                    onChange={() => {
                      if (!isItemActive) {
                        warningItem.current = item
                        setIsWarning(true)
                      } else {
                        updatePermission(role_id, item?.permission_id, item?.enabled)
                      }
                    }}
                    onColor={primary_color}
                    // checked={preferanceForm[item.field_id]?.print}
                    // onChange={(value) =>
                    //   updatePreferanceForm({
                    //     ...preferanceForm,
                    //     [item.field_id]: {
                    //       ...preferanceForm[item.field_id],
                    //       print: value,
                    //     },
                    //   })
                    // }
                    uncheckedIcon={<i className='fa-thin fa-xmark switch-icon'></i>}
                    checkedIcon={<i className='fa-thin fa-check switch-icon'></i>}
                    className='d-inline'
                  />
                  <div className='ml-4 font-weight-bold subtitle1'>{tidyName(key)}</div>
                </div>
              )
            })}
        </div>

        {isManagePermissionActive && isManagePermissionRoleEnabled && (
          <div>
            <RowTitle title={'Manage Roles'} />

            <ManagePermissionRole roles={currentPermission?.manage_roles} type='manage_roles' role_id={role_id} />
          </div>
        )}
        {isChangePermissionRoleEnabled && isChangePermissionActive && isManagePermissionRoleEnabled && (
          <div>
            <RowTitle title={'Assign Roles to Users'} />
            <ManagePermissionRole roles={currentPermission?.assign_roles_to_users} type='assign_roles_to_users' role_id={role_id} />
          </div>
        )}
      </div>
      <Modal
        isOpen={isWarning}
        centered={true}
        toggle={() => {
          setIsWarning(false)
          warningItem.current = null
        }}
        style={{ width: '28rem', boxShadow: 'none' }}>
        <ModalHeader style={{ backgroundColor: '#FFF', border: 'none' }}>
          <div className='body1 font-weight-bold' style={{ color: primary_color }}>
            Are you sure you want to continue assigning manage permissions to this role, thereby granting access to this role?
          </div>
        </ModalHeader>
        <ModalBody>
          <div className='d-flex justify-content-between'>
            <button
              className='btn text-white rounded-pill mt-2'
              type='button'
              onClick={() => {
                setIsWarning(false)
                updatePermission(role_id, warningItem?.current?.permission_id, warningItem?.current?.enabled)
                warningItem.current = null
              }}
              style={{ background: primary_color, fontWeight: 700, width: '48%' }}>
              Yes
            </button>
            <button
              className='btn rounded-pill mt-2 text-danger border-danger'
              type='button'
              onClick={() => {
                setIsWarning(false)
                warningItem.current = null
              }}
              style={{ fontWeight: 700, width: '48%' }}>
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default CMSPermissionPanel
